import React from "react";
import ThemeTogglerTwo from "../../components/common/ThemeTogglerTwo";

interface AuthLayoutProps {
  children: React.ReactNode;
  hideSignupHighlight?: boolean;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      className="neo-auth fixed inset-0 overflow-y-auto overflow-x-hidden text-[var(--ink2)]"
      style={{
        zIndex: 1,
        background: "var(--wash), var(--page)",
        backgroundAttachment: "fixed",
      }}
    >
   
      {/* <img
        src="/images/shape/grid-01.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 w-[250px] xl:w-[450px]"
        style={{ zIndex: 0, opacity: 0.55 }}
      />
     
      <img
        src="/images/shape/grid-01.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-0 w-[250px] xl:w-[450px] rotate-180"
        style={{ zIndex: 0, opacity: 0.55 }}
      /> */}
      <div
        className="flex min-h-full flex-col lg:flex-row relative"
        style={{ zIndex: 2 }}
      >
        <div className="flex flex-1 flex-col items-center p-4 sm:p-6 lg:w-1/2">
          {children}
        </div>
        {/* <div className="hidden items-center lg:grid lg:w-1/2 h-full bg-brand-950 dark:bg-white/5 dark:bg-gray-900 lg:pr-20">
          <div className="relative flex items-center justify-center z-1">
        
            <GridShape />
            <div className="flex flex-col items-center max-w-md">
              <Link to="/" className="block hidden mb-4">
                <img
                  width={231}
                  height={48}
                  src="/images/neo-logo/neo-logo.svg"
                  alt="Logo"
                />
              </Link>
              <Link to="/" className="black-logo mb-4">
                <img
                  width={231}
                  height={48}
                  src="/images/neo-logo/neo-logo.svg"
                  alt="Logo"
                />
              </Link>
              <p className="text-center text-gray-600 dark:text-white width-full">
               Where your business data turns into clear insights and faster decisions.
              </p>
              {!hideSignupHighlight && (
                <div className="mobile-im-sig">
                  <img
                    className="my-3  max-w-sm"
                    src="/images/logo/signup-page-mobile.png"
                    alt="Neo"
                    width={280}
                    height={70}
                  />
                  <ul className="text-gray-600 dark:text-white width-full dot-primary-si text-center">
                    <li>
                      <span></span> Integrate within&nbsp;2 mins
                    </li>
                    <li>
                      <span></span> Get daily reports on&nbsp;WhatsApp
                    </li>
                    <li>
                      <span></span> Get key D2C metrics at one place
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div> */}
        <div className="fixed z-50 bottom-6 right-6">
          <ThemeTogglerTwo />
        </div>
      </div>
    </div>
  );
}
